import i18n from "../i18n";
export const changeLanguage = (lng) => {
  i18n.changeLanguage(lng);
  localStorage.setItem('language', lng);
}


export const limitCharacters = (text, maxChars = 40) => {
  if (!text) return "";

  const trimmed = text.trim();
  return trimmed.length > maxChars
    ? trimmed.slice(0, maxChars) + "..."
    : trimmed;
};


export const nativeShare = async (shareTitle, shareText, shareUrl) => {
  if (navigator.share) {
    try {
      await navigator.share({
        title: shareTitle,
        text: shareText,
        url: shareUrl
      });

    } catch (err) {
      if (err.name !== 'AbortError') console.warn('Share failed:', err);
    }
  }
};


export const brandName="DATY ABAYA TZ"